export const setRooms = (rooms) => ({
	type: 'SET_ROOMS',
	payload: { rooms }
});

export const removeRoom = (id) => ({
	type: 'REMOVE_ROOM',
	payload: { id }
});

export const addRoom = (room) => ({
	type: 'ADD_ROOM',
	payload: { room }
});

export const updateRoom = (room) => ({
	type: 'UPDATE_ROOM',
	payload: { room }
});

export const joinUserIntoRoom = (user, roomId) => ({
	type: 'JOIN_USER_TO_ROOM',
	payload: { user, roomId }
});

export const removeUserFromRoom = (userId) => ({
	type: 'REMOVE_USER_FROM_ROOM',
	payload: { userId }
});
